<template>
  <v-container style="padding: 0px" class="leftbox">
    <v-layout row wrap class="hidden-sm-and-down">
      <v-flex sm12 md12 lg12 xl12>
        <v-list dense style="padding-top: 0px;" class="layoutsearchweb">
          <v-container class="layoutsearchweb">
            <v-layout row wrap class="layoutsearchweb">
              <v-flex xl12 md12 sm12 lg12>
                <div class="Kanit cardleftsidemenu" @click="gotoLink('/develop/information_dev')">
                  <v-layout>
                    <v-flex xl4 md4 sm4 lg4 style="height: 100%;text-align:center;">
                      <v-avatar size="50px" style="margin-top: 1vh;">
                        <img :src="(profilepicture != '')? profilepicture:'../../../static/img/robot/developer1.png'" class="alligator-turtle" style="cursor: pointer;">
                      </v-avatar>
                    </v-flex>
                    <v-flex xl6 md6 sm6 lg6 style="height: 100%;word-wrap: break-word; padding-top: 1vh;">
                      <div style="font-size:23px;word-wrap: break-word; width: 100%; text-align:left;white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                        <span style="font-size: 15px; font-weight: 700;">ข้อมูล API</span>
                      </div>
                    </v-flex>
                    <v-flex xl2 md2 sm2 lg2 style="height: 100%;text-align:center;margin-top: 3vh;  ">
                      <v-icon style="    font-size: 18px;">settings</v-icon>
                    </v-flex>
                  </v-layout>
                </div>
              </v-flex>
              <v-flex xl12 md12 sm12 lg12 style="margin-top: 10px;">
                <div class="Kanit cardleftsidemenu" @click="gotoLink('/develop/createbot')">
                  <v-layout>
                    <v-flex xl4 md4 sm4 lg4 style="height: 100%;text-align:center;">
                      <v-avatar size="50px" style="margin-top: 1vh;">
                        <img src='/static/img/robot/robot2.png' class="alligator-turtle" style="cursor: pointer;" />
                      </v-avatar>
                    </v-flex>
                    <v-flex xl6 md6 sm6 lg6 style="height: 100%;word-wrap: break-word; padding-top: 1vh;">
                      <div style="font-size:23px; word-wrap: break-word; width: 100%; text-align:left; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                        <span style="font-size: 15px; font-weight: 700;">สร้างบอท</span>
                      </div>
                    </v-flex>
                    <v-flex xl2 md2 sm2 lg2 style="height: 100%;text-align:center;margin-top: 3vh;  ">
                      <v-icon style="    font-size: 18px;">create</v-icon>
                    </v-flex>
                  </v-layout>
                </div>
              </v-flex>
              <v-flex xl12 md12 sm12 lg12 style="max-height: 80vh;">
                <!-- ------------------------------------------------------- -->
                <v-expansion-panel style="margin-top: 10px; border-radius: 10px; box-shadow: none;">
                  <v-expansion-panel-content class="expansion_container Kanit">
                    <b slot="header" class="Kanit">{{(FilterFriendList.length != 0)? 'รายชื่อ บอท (' + FilterFriendList.length + ')':'ไม่มีรายการบอท'}}</b>
                    <v-list subheader class="scroll-y expanvlist_body" v-if="FilterFriendList.length != 0">
                      <template v-for="(item, index) in FilterFriendList">
                        <div avatar @click="routeProfile(item)" style="padding-top: 0px;cursor: pointer;">
                          <v-list-tile avatar :class="(actionF == item.bot_id)? 'selectF':'nonselectF'">
                            <v-list-tile-avatar style="padding-left: 1vw;margin-right: 1vw;">
                              <img :src="item.profilepicture? item.profilepicture:'../../../static/img/robot/robot1.png'" class="alligator-turtle" />
                            </v-list-tile-avatar>
                            <v-list-tile-content style="margin-right: 0vw;padding-right: 1vw;">
                              <v-list-tile-title class="fontname">
                                {{item.nickname}}
                              </v-list-tile-title>
                              <v-list-tile-sub-title class="fontstatus">
                                <span v-if="item.status !== ''">
                                  {{item.status}}
                                </span>
                              </v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </div>
                        <v-divider style="border-top:none; border-bottom: 1px solid #f0f0f0 !important;"></v-divider>
                      </template>
                    </v-list>
                  </v-expansion-panel-content>
                  <v-expansion-panel-content class="expansion_container Kanit" style="margin-top: 10px;">
                    <b slot="header" class="Kanit">เอกสาร API</b>
                    <v-list class="expansion_container Kanit" style="max-height: 50vh;overflow-y: scroll;">
                      <v-list-group v-for="item in items" v-model="item.active" :key="item.title">
                        <v-list-tile slot="activator">
                          <v-list-tile-content>
                            <v-list-tile-title style="padding-left: 2vw;">{{ item.title }}
                              <span v-if="item.status == 'new'">
                                <v-icon style="color: #44CD16 !important;font-size: 20px;">fiber_new</v-icon>
                              </span>
                            </v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile v-for="subItem in item.items" :key="subItem.title" @click="link(subItem.link)" class="selectF">
                          <v-list-tile-action>
                            <v-icon style="color:white; font-size: 20px;">{{ subItem.icon }}</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title style="">
                              <v-layout row wrap>
                                <v-flex>
                                  {{ subItem.title }}
                                </v-flex>
                                <v-flex>
                                  <span v-if="subItem.status == 'new'">
                                    <v-icon style="color: #44CD16 !important;font-size: 20px;">fiber_new</v-icon>
                                  </span>
                                </v-flex>
                              </v-layout>
                            </v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list-group>
                    </v-list>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-flex>
              <!-- ------------------------------------------------------- -->
            </v-layout>
          </v-container>
        </v-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import { mapState } from 'vuex'
export default {
  data: () => ({
    items: [
      {
        action: 'local_activity',
        title: 'เริ่มต้นการใช้งาน',
        active: true,
        items: [
          {title: 'เริ่มต้นการใช้งาน API', link: '/develop/docs', icon: 'info'}
        ]
      },
      {
        action: 'far fa-file-code',
        title: 'คู่มือการใช้งาน API',
        active: false,
        items: [
          {title: 'การยืนยันตัวตน', link: '/develop/docs/authorization', icon: 'person'}
        ]
      },
      {
        action: 'far fa-file-code',
        title: 'ข้อมูลเกี่ยวกับบอท',
        active: false,
        items: [
          {title: 'ข้อมูลเพื่อนและกลุ่ม', link: '/develop/docs/aboutbot/getlistroom', icon: 'person'},
          {title: 'ค้นหาข้อมูลเพื่อน', link: '/develop/docs/aboutbot/searchfriend', icon: 'search'}
        ]
      },
      {
        action: 'far fa-file-code',
        title: 'การส่งข้อความ',
        active: false,
        // status: 'new',
        items: [
          {title: 'การส่งข้อความ', link: '/develop/docs/webhook/reply_message', icon: 'fas fa-comment-alt'},
          {title: 'การส่งข้อความ (หลายห้องแชท)',
            link: '/develop/docs/webhook/message_group_broadcast',
            icon: 'fas fa-comment-alt',
            status: 'new'
          },
          {title: 'การส่งเทมเพลต (หลายห้องแชท)',
            link: '/develop/docs/webhook/template_group_broadcast',
            icon: 'fas fa-comment-alt',
            status: 'new'
          },
          {title: 'การส่งไฟล์', link: '/develop/docs/webhook/reply_file', icon: 'fas fa-file'},
          {title: 'การส่งโลเคชัน', link: '/develop/docs/webhook/reply_location', icon: 'map'},
          {title: 'การส่งสติ๊กเกอร์', link: '/develop/docs/webhook/reply_sticker', icon: 'photo'},
          {title: 'การส่งเว็บวิว', link: '/develop/docs/webhook/reply_webview', icon: 'web'},
          {title: 'การส่งแบบฟอร์มการยืนยัน', link: '/develop/docs/webhook/reply_approve', icon: 'far fa-thumbs-up'}
        ]
      },
      {
        action: 'far fa-file-code',
        title: 'การส่งเทมเพลต',
        active: false,
        // status: 'new',
        items: [
          {title: 'เกี่ยวกับ Template', link: '/develop/docs/template/abouttemplate', icon: 'info'},
          {title: 'ประเภทข้อความ', link: '/develop/docs/template/template_message', icon: 'chat'},
          {title: 'ประเภทลิงก์', link: '/develop/docs/template/template_link', icon: 'link'},
          {title: 'ประเภทเว็บวิว', link: '/develop/docs/template/template_webview', icon: 'web'},
          {title: 'ประเภทไฟล์', link: '/develop/docs/template/template_file', icon: 'fas fa-file'}
        ]
      },
      {
        action: 'far fa-file-code',
        title: 'การสร้าง Quick Reply',
        active: false,
        // status: 'new',
        items: [
          {title: 'เกี่ยวกับ Quick Reply', link: '/develop/docs/quickreply/aboutquickreply', icon: 'info'},
          {title: 'ประเภทข้อความ', link: '/develop/docs/quickreply/quickreply_text', icon: 'chat'},
          {title: 'ประเภทลิงก์', link: '/develop/docs/quickreply/quickreply_link', icon: 'link'},
          {title: 'ประเภทเว็บวิว', link: '/develop/docs/quickreply/quickreply_webview', icon: 'web'},
          {title: 'ประเภทเลือกวัน', link: '/develop/docs/quickreply/quickreply_datepicker', icon: 'date_range'},
          {title: 'ประเภทเลือกวันเวลา', link: '/develop/docs/quickreply/quickreply_datetimepicker', icon: 'access_time'},
          {title: 'ประเภทโลเคชัน', link: '/develop/docs/quickreply/quickreply_location', icon: 'location_on', status: 'new'},
          {title: 'ประเภทรูปภาพ', link: '/develop/docs/quickreply/quickreply_image', icon: 'photo', status: 'new'},
          {title: 'ประเภทไฟล์', link: '/develop/docs/quickreply/quickreply_file', icon: 'fas fa-file', status: 'new'}
          // {title: 'ประเภท OCR', link: '/develop/docs/quickreply/quickreply_ocr', icon: 'qr_code_scanner', status: 'new'},
          // {title: 'ประเภทไฟล์', link: '/docs/quickreply/quickreply_file', icon: 'fas fa-file'}
        ]
      },
      {
        action: 'far fa-file-code',
        title: 'การสร้าง Bottom Menu',
        active: false,
        status: 'new',
        items: [
          {title: 'การสร้าง Bottom Menu', link: '/develop/docs/bottommeunu/aboutbottommeunu', icon: 'widgets', status: 'new'},
          {title: 'การดึงข้อมูลผู้ใช้', link: '/develop/docs/bottommeunu/getprofile', icon: 'account_circle', status: 'new'}
        ]
      },
      {
        action: 'far fa-file-code',
        title: 'การสร้าง Image Carousel',
        active: false,
        // status: 'new',
        items: [
          {title: 'เกี่ยวกับ Image Carousel', link: '/develop/docs/carouselimage/aboutimagecarousel', icon: 'info', status: 'new'},
          {title: 'ประเภทข้อความ', link: '/develop/docs/carouselimage/carouselimage_msg', icon: 'chat'},
          {title: 'ประเภทลิงก์', link: '/develop/docs/carouselimage/carouselimage_link', icon: 'link'},
          {title: 'ประเภทเว็บวิว', link: '/develop/docs/carouselimage/carouselimage_webview', icon: 'web'},
          {title: 'ประเภทรูปภาพ', link: '/develop/docs/carouselimage/carouselimage_image', icon: 'photo'},
          {title: 'ประเภทpostback', link: '/develop/docs/carouselimage/carouselimage_postback', icon: 'web_asset'}
        ]
      },
      {
        action: 'far fa-file-code',
        title: 'WebHooks',
        active: false,
        items: [
          {title: 'เกี่ยวกับ webhook', link: '/develop/docs/webhook/aboutwebhook', icon: 'info'},
          {title: 'การรับข้อมูลแบบข้อความ', link: '/develop/docs/webhook/receive_message', icon: 'chat'},
          {title: 'การรับข้อมูลแบบไฟล์ต่างๆ', link: '/develop/docs/webhook/receive_file', icon: 'attach_file'},
          {title: 'การรับข้อมูลแบบโลเคชั่น', link: '/develop/docs/webhook/receive_location', icon: 'location_on'},
          {title: 'การรับข้อมูลแบบสติ๊กเกอร์', link: '/develop/docs/webhook/receive_sticker', icon: 'insert_photo'},
          {title: 'การรับข้อมูลคิวอาร์โค้ดจาก Bottom Menu', link: '/develop/docs/webhook/receive_qrcode', icon: 'qr_code'},
          {title: 'มีการเพิ่มบอทเป็นเพื่อน', link: '/develop/docs/webhook/noti_addbot', icon: 'person_add'},
          {title: 'มีการเพิ่มบอทเข้ากลุ่ม', link: '/develop/docs/webhook/noti_addgroup', icon: 'group_add'},
          {title: 'มีการลบบอทออกจากกลุ่ม', link: '/develop/docs/webhook/noti_leavegroup', icon: 'delete'}
        ]
      }
    ],
    search: '',
    username: '',
    listbot: [],
    actionF: '',
    token: '',
    GroupReq: [],
    active: null,
    webbackend: '',
    profilepicture: '',
    myname: ''
  }),
  created () {
    this.removefriend = false
    this.webbackend = process.env.API
    this.actionF = this.$route.params.id
    this.profilepicture = localStorage.getItem('profilepicture')
    this.myname = localStorage.getItem('name')

    this.username = localStorage.getItem('myUsername')
    this.token = localStorage.getItem('tokenuser')
    this.typeuser = localStorage.getItem('usertype')
    this.$http.post(process.env.APImanage + '/web/getlistbot', {tokenuser: this.token}).then((response) => {
      this.listbot = response.body['listbot']
    })
  },
  methods: {
    link (link) {
      this.$router.push(link)
    },
    gotoLink (link) {
      if (link === 'logout') {
        this.logout()
      } else {
        this.$router.push(link)
      }
    },
    routeProfile (data) {
      if (data === undefined) {
        this.$store.dispatch('tokenRoom', 'noneselect')
        this.$store.dispatch('changeRightTool', 'Friend')
        this.$cookies.set('tokenRoom', 'noneselect')
        localStorage.setItem('room', 'noneselect')
        this.$store.dispatch('changeBot', 'noneselect')
      } else {
        this.$store.dispatch('tokenRoom', data.bot_id)
        this.$store.dispatch('changeBot', data)
        localStorage.setItem('room', data.bot_id)
        this.actionF = data.bot_id
        this.$store.dispatch('changeRightTool', 'Friend')
        this.$cookies.set('tokenRoom', data.bot_id)
        this.$router.push('/develop/homepage/' + data.bot_id + '/' + data.tokenuser)
      }
    }
  },
  computed: {
    FilterFriendList () {
      if (this.search !== '' && this.search !== null) {
        return this.listbot.filter(post => {
          return post.name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return this.listbot
      }
    },
    ...mapState({
      listfriend: 'listfriend',
      myprofile: 'myprofile',
      botinfo: 'botinfo'
    })
  },
  watch: {
    listfriend () {
      this.actionF = this.$route.params.id
      this.$http.post(process.env.APImanage + '/web/getlistbot', {tokenuser: this.token}).then((response) => {
        this.listbot = response.body['listbot']
      })
      // })
    },
    myprofile () {
      this.profilepicture = localStorage.getItem('profilepicture')
      this.myname = localStorage.getItem('name')
    },
    botinfo () {
      this.actionF = this.$route.params.id
      this.$http.post(process.env.APImanage + '/web/getlistbot', {tokenuser: this.token}).then((response) => {
        this.listbot = response.body['listbot']
      })
      // })
    }
  }
}
</script>
<style type="text/css" scoped>
.container {
  max-width: 300px;
}

.input-group--text-field input {
  color: white !important;
}


.layoutsearchweb {
  background-color: #e0eeff !important;
  color: white !important;
}

.bgsearchweb {
  background-color: #232a35 !important;
  color: white !important;
  border-radius: 100px !important;
  font-size: 12px !important;
  margin-top: 2vh !important;
  margin-bottom: 2vh !important;
}


.leftbox {
  height: 100%;
  background-color: #e0eeff !important;
  overflow: hidden !important;
  position: fixed;
}

.fontselect {
  /*color: white !important;*/
  color: #53CEFF !important;
  /*font-family: 'CS ChatThaiUI' !important;*/
  font-size: 13px;
  /*font-weight: 700;*/
  /*font-family: 'Kanit', sans-serif !important;*/
}

.nonfontselect {
  /*color: white !important;*/
  color: white !important;
  /*font-family: 'CS ChatThaiUI' !important;*/
  font-size: 13px;
  /*font-weight: 700;*/
  /*font-family: 'Kanit', sans-serif !important;*/
}

.fontselectchat {
  color: #bdbdbd !important;
  /*font-family: 'CS ChatThaiUI' !important;*/
  font-size: 11px !important;
  /*font-family: 'Kanit', sans-serif !important;*/
}

.Kanit {
  font-family: 'Kanit', sans-serif !important;
  word-wrap: break-word;
}

.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}

.selectF {
  background-color: #232a35a6 !important;
  width: 100%;
  font-family: 'Kanit' !important;
  padding: 5px 0px 5px 0px;
}

.nonselectF {
  background-color: white !important;
  width: 100%;
  font-family: 'Kanit' !important;
  padding: 5px 0px 5px 0px;
}

.nonselectF .fontname {
  font-size: 13px;
  font-weight: 500;
  color: #2463af !important;
}

.selectF .fontname {
  color: #53CEFF !important;
  font-size: 13px;
  font-weight: 500;
}

.nonselectF .fontstatus {
  color: #7a7a7a !important;
  font-size: 10px !important;
}

.selectF .fontstatus {
  color: #bdbdbd !important;
  font-size: 11px !important;
}


.headerlist {
  color: white !important;
  font-weight: 700;
}

.tabs__item--active {
  opacity: 1;
  color: #53ceff !important;
}

.application .theme--light.tabs__bar .tabs__li,
.theme--light .tabs__bar .tabs__li--active {
  color: #53CEFF !important;
}

.btn--floating {
  height: 23px !important;
  width: 23px !important;
}

.cardlist {
  padding-top: 10px;
  width: 100%;
  height: 30vh;
  overflow-x: hidden;
  overflow-y: scroll;
}

.cardlist::-webkit-scrollbar {
  width: 10px;
}

.cardlist::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(0, 0, 0, .1);
}

.list__tile .list__tile--link .list__tile--avatar {
  padding: 0px !important;
}

.list .list--three-line {
  background-color: #2a476c !important;
}

.list .list--dense {
  background-color: #2a476c !important;
}

.tabs__container {
  justify-content: center !important;
}

.material-icons .icon .icon--right {
  display: none;
}

.alligator-turtle {

  object-fit: cover;
  object-position: 50% 0;
}

.fixed-content {
  min-height: 100%;
  /*position:fixed;*/
  overflow-y: scroll;
  overflow-x: hidden;
}

.application .theme--light.input-group:not(.input-group--error) label,
.theme--light .input-group:not(.input-group--error) label {
  color: rgba(0, 0, 0, .54);
  padding-left: 0.5vw;
  padding-right: 0.5vw;
}


.application .theme--light.list .list__tile:not(.list__tile--active),
.theme--light .list .list__tile:not(.list__tile--active) {
  padding: 0px !important;
}

.nonselect_Menu {
  color: rgb(119, 119, 119) !important;
  background-color: #2a476c !important;
}

.select_Menu {
  color: white !important;
  background-color: #27303e !important;
}

.application .theme--light.expansion-panel .expansion-panel__container .expansion-panel__header .icon,
.theme--light .expansion-panel .expansion-panel__container .expansion-panel__header .icon {
  /*color: rgba(204, 204, 204, 0.54);*/
  color: white;
}

.application .theme--light.input-group:not(.input-group--error) label,
.theme--light .input-group:not(.input-group--error) label {
  /*color: #ffffff52 !important;*/
  color: #f5f5f5 !important;
  font-size: 16px;
  padding-left: 10px;
}

.application .theme--light.input-group:not(.input-group--error):not(.input-group--focused):not(.input-group--disabled) .input-group__input .input-group__append-icon:not(:hover),
.application .theme--light.input-group:not(.input-group--error):not(.input-group--focused):not(.input-group--disabled) .input-group__input .input-group__prepend-icon:not(:hover),
.theme--light .input-group:not(.input-group--error):not(.input-group--focused):not(.input-group--disabled) .input-group__input .input-group__append-icon:not(:hover),
.theme--light .input-group:not(.input-group--error):not(.input-group--focused):not(.input-group--disabled) .input-group__input .input-group__prepend-icon:not(:hover) {
  color: #ffffff52 !important;
}

.expansion_container {
  width: 100%;
  background: #232a35 !important;
  color: white !important;
  border-radius: 10px;
  padding: 0px;
}

::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  /* background: #2a476c; */
  background: rgba(230, 230, 230, 0.2);
}

::-webkit-scrollbar-thumb {
  background: #888;
}

.cardleftsidemenu {
  color: white;
  height: 72px;
  background-color: #1976d2 !important;
  width: 100%;
  border-radius: 15px;
  cursor: pointer;
}

.cardleftsidemenu:hover {
  background-color: #2463af !important;
}

.expanvlist_body {
  padding: 0px;
  background-color: #2a476c !important;
  width: 100%;
  max-height: 50vh;
  border-radius: 0px 0px 10px 10px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/managebot/leftpage.vue